@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="TagList"
    [filterable]="true"
    (filterChange)="filterTags($event)"
    [allowCustom]="true"
    [valueNormalizer]="valueNormalizer"
    [(ngModel)]="Tags"
    placeholder="Wählen Sie einen Wert aus"
    (valueChange)="valueChanged()">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [data]="TagList"
    [(ngModel)]="Tag"
    (valueChange)="valueChanged()">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
